"use client";
import { useGetQuery } from "@/hooks";
import styles from "./index.module.scss";
import Translate from "@/i18n";
import { UseQueryResult, useQueryClient } from "@/utils/@tanstack/react-query";
import InitInterface from "@/types/initInterface";
import Link from "next/link";
import { Activity } from "@/utils/constants";
import { generateUrl, removeUserData } from "@/utils/common";
import { useParams } from "next/navigation";
import { Locale } from "@/i18n/i18n-config";

export default function ActivityList() {
  const { data } = useGetQuery(["init"]) as UseQueryResult<InitInterface>;
  const queryClient = useQueryClient();
  const params = useParams<{ lang: Locale }>();
  const logoutUser = () => {
    queryClient.setQueryData(["init"], false);
    removeUserData();
  };

  return (
    <main className={styles.content}>
      <h1>{data?.data?.name}</h1>
      <h1>
        <Translate text="select_leaderboard" />
      </h1>
      <div className={styles.list}>
        <div>
          <Link href={generateUrl("/overall", params.lang)}>
            {Activity["overall"]}
          </Link>
        </div>
        {data?.data?.performances.map((item) => (
          <div key={item.value}>
            <Link href={generateUrl(`/${item.value}`, params.lang)}>
              {Activity[item.value]}
            </Link>
          </div>
        ))}
      </div>
      <div className={styles.config}>
        <Link href={generateUrl(`/performance`, params.lang)}>
          <Translate text="open_performance_tool" />
        </Link>
      </div>
      <div className={styles.newEvent}>
        <Link href={generateUrl(`/search-participant`, params.lang)}>
          <Translate text="search_for_participant" />
        </Link>
      </div>
      <div className={styles.newEvent} onClick={() => logoutUser()}>
        <Translate text="logout_from_event" />
      </div>
    </main>
  );
}
